<template>
  <div class="page-content" v-loading="loading">
    <Item v-for="item in list" :key="item.id" :item="item"></Item>
    <div class="z-pagination" v-if="total">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="current_page"
        :page-size.sync="per_page"
        layout="prev, pager, next"
        :total="total"
      >
      </el-pagination>
      <span class="z-pagination__total"> 共 {{ total }} 条 </span>
    </div>
  </div>
</template>

<script>
import Item from "./Item.vue";
import { getLianzhengzhengcefaguiPage as getList } from "@/apis/lianzheng";
export default {
  components: {
    Item,
  },
  data() {
    return {
      per_page: 10,
      current_page: 1,
      total: 0,
      list: [],
      loading: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleCurrentChange(page) {
      this.$emit("currentChange", page);
      this.getList();
    },
    async getList() {
      this.loading = true;
      const { data } = await getList({
        page: this.current_page,
        pagenum: this.per_page,
      });

      this.total = data.total;
      this.per_page = data.per_page;
      this.current_page = data.current_page;
      this.list = data.data;
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-content {
  min-height: 400px;
}
</style>
